"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeSchemaSchema = void 0;
exports.ContentTypeSchemaSchema = {
    "$id": "https://www.redbull.com/schemas/types/content.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentTypeSchema",
    "description": "Meta schema for content type definition",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^(attributes|rrn:content|rrn:types|rrn:content:ext:services|rrn:abstract|rrn:patch):([a-zA-Z0-9\\d\\-_]+)(:([\\d]+))?$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:types:content"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "displayName": {
                    "type": "string",
                    "pattern": "^[A-Za-z0-9]+$"
                },
                "description": {
                    "type": "string"
                },
                "attributes": {
                    "type": "object",
                    "additionalProperties": false,
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "string",
                                                "format": "uri"
                                            },
                                            {
                                                "type": "string",
                                                "enum": [
                                                    "boolean",
                                                    "integer",
                                                    "number",
                                                    "string"
                                                ]
                                            }
                                        ]
                                    },
                                    "minItems": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "calculated": {
                                    "type": "boolean"
                                },
                                "deprecated": {
                                    "type": "string"
                                },
                                "enum": {
                                    "type": "array"
                                },
                                "multiple": {
                                    "type": "boolean"
                                },
                                "required": {
                                    "type": "boolean"
                                },
                                "pattern": {
                                    "type": "string"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "relationships": {
                    "type": "object",
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "oneOf": [
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string",
                                                "format": "uri"
                                            },
                                            "minItems": 1
                                        },
                                        {
                                            "type": "object",
                                            "properties": {
                                                "oneOf": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string",
                                                        "format": "uri"
                                                    },
                                                    "minItems": 1
                                                },
                                                "anyOf": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string",
                                                        "format": "uri"
                                                    },
                                                    "minItems": 1
                                                },
                                                "allOf": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string",
                                                        "format": "uri"
                                                    },
                                                    "minItems": 1
                                                }
                                            }
                                        }
                                    ]
                                },
                                "description": {
                                    "type": "string"
                                },
                                "calculated": {
                                    "type": "boolean"
                                },
                                "deprecated": {
                                    "type": "string"
                                },
                                "multiple": {
                                    "type": "boolean"
                                },
                                "required": {
                                    "type": "boolean"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "meta": {
                    "type": "object",
                    "additionalProperties": false,
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "maxItems": 1,
                                    "minItems": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "calculated": {
                                    "type": "boolean"
                                },
                                "deprecated": {
                                    "type": "string"
                                },
                                "enum": {
                                    "type": "array"
                                },
                                "multiple": {
                                    "type": "boolean"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "deprecated": {
                    "type": "string"
                }
            },
            "required": [
                "displayName"
            ]
        },
        "relationships": {
            "type": "object",
            "properties": {
                "groups": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:type-groups:"
                                    },
                                    "type": {
                                        "type": "string",
                                        "enum": [
                                            "rrn:type-groups"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                },
                "inherits": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string"
                                    },
                                    "type": {
                                        "type": "string",
                                        "enum": [
                                            "rrn:types:content"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "required": [
        "attributes",
        "id",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy90eXBlcy9jb250ZW50LnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLEtBQUssRUFBRSwyREFBMkQ7SUFDbEUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsbUJBQW1CO0lBQzVCLGFBQWEsRUFBRSx5Q0FBeUM7SUFDeEQsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsd0hBQXdIO1NBQ3BJO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLG1CQUFtQjthQUNwQjtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osYUFBYSxFQUFFO29CQUNiLE1BQU0sRUFBRSxRQUFRO29CQUNoQixTQUFTLEVBQUUsZ0JBQWdCO2lCQUM1QjtnQkFDRCxhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2dCQUNELFlBQVksRUFBRTtvQkFDWixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsc0JBQXNCLEVBQUUsS0FBSztvQkFDN0IsbUJBQW1CLEVBQUU7d0JBQ25CLGFBQWEsRUFBRTs0QkFDYixNQUFNLEVBQUUsUUFBUTs0QkFDaEIsc0JBQXNCLEVBQUUsS0FBSzs0QkFDN0IsWUFBWSxFQUFFO2dDQUNaLE1BQU0sRUFBRTtvQ0FDTixNQUFNLEVBQUUsT0FBTztvQ0FDZixPQUFPLEVBQUU7d0NBQ1AsT0FBTyxFQUFFOzRDQUNQO2dEQUNFLE1BQU0sRUFBRSxRQUFRO2dEQUNoQixRQUFRLEVBQUUsS0FBSzs2Q0FDaEI7NENBQ0Q7Z0RBQ0UsTUFBTSxFQUFFLFFBQVE7Z0RBQ2hCLE1BQU0sRUFBRTtvREFDTixTQUFTO29EQUNULFNBQVM7b0RBQ1QsUUFBUTtvREFDUixRQUFRO2lEQUNUOzZDQUNGO3lDQUNGO3FDQUNGO29DQUNELFVBQVUsRUFBRSxDQUFDO2lDQUNkO2dDQUNELGFBQWEsRUFBRTtvQ0FDYixNQUFNLEVBQUUsUUFBUTtpQ0FDakI7Z0NBQ0QsWUFBWSxFQUFFO29DQUNaLE1BQU0sRUFBRSxTQUFTO2lDQUNsQjtnQ0FDRCxZQUFZLEVBQUU7b0NBQ1osTUFBTSxFQUFFLFFBQVE7aUNBQ2pCO2dDQUNELE1BQU0sRUFBRTtvQ0FDTixNQUFNLEVBQUUsT0FBTztpQ0FDaEI7Z0NBQ0QsVUFBVSxFQUFFO29DQUNWLE1BQU0sRUFBRSxTQUFTO2lDQUNsQjtnQ0FDRCxVQUFVLEVBQUU7b0NBQ1YsTUFBTSxFQUFFLFNBQVM7aUNBQ2xCO2dDQUNELFNBQVMsRUFBRTtvQ0FDVCxNQUFNLEVBQUUsUUFBUTtpQ0FDakI7NkJBQ0Y7NEJBQ0QsVUFBVSxFQUFFO2dDQUNWLE1BQU07NkJBQ1A7eUJBQ0Y7cUJBQ0Y7aUJBQ0Y7Z0JBQ0QsZUFBZSxFQUFFO29CQUNmLE1BQU0sRUFBRSxRQUFRO29CQUNoQixtQkFBbUIsRUFBRTt3QkFDbkIsYUFBYSxFQUFFOzRCQUNiLE1BQU0sRUFBRSxRQUFROzRCQUNoQixzQkFBc0IsRUFBRSxLQUFLOzRCQUM3QixZQUFZLEVBQUU7Z0NBQ1osTUFBTSxFQUFFO29DQUNOLE9BQU8sRUFBRTt3Q0FDUDs0Q0FDRSxNQUFNLEVBQUUsT0FBTzs0Q0FDZixPQUFPLEVBQUU7Z0RBQ1AsTUFBTSxFQUFFLFFBQVE7Z0RBQ2hCLFFBQVEsRUFBRSxLQUFLOzZDQUNoQjs0Q0FDRCxVQUFVLEVBQUUsQ0FBQzt5Q0FDZDt3Q0FDRDs0Q0FDRSxNQUFNLEVBQUUsUUFBUTs0Q0FDaEIsWUFBWSxFQUFFO2dEQUNaLE9BQU8sRUFBRTtvREFDUCxNQUFNLEVBQUUsT0FBTztvREFDZixPQUFPLEVBQUU7d0RBQ1AsTUFBTSxFQUFFLFFBQVE7d0RBQ2hCLFFBQVEsRUFBRSxLQUFLO3FEQUNoQjtvREFDRCxVQUFVLEVBQUUsQ0FBQztpREFDZDtnREFDRCxPQUFPLEVBQUU7b0RBQ1AsTUFBTSxFQUFFLE9BQU87b0RBQ2YsT0FBTyxFQUFFO3dEQUNQLE1BQU0sRUFBRSxRQUFRO3dEQUNoQixRQUFRLEVBQUUsS0FBSztxREFDaEI7b0RBQ0QsVUFBVSxFQUFFLENBQUM7aURBQ2Q7Z0RBQ0QsT0FBTyxFQUFFO29EQUNQLE1BQU0sRUFBRSxPQUFPO29EQUNmLE9BQU8sRUFBRTt3REFDUCxNQUFNLEVBQUUsUUFBUTt3REFDaEIsUUFBUSxFQUFFLEtBQUs7cURBQ2hCO29EQUNELFVBQVUsRUFBRSxDQUFDO2lEQUNkOzZDQUNGO3lDQUNGO3FDQUNGO2lDQUNGO2dDQUNELGFBQWEsRUFBRTtvQ0FDYixNQUFNLEVBQUUsUUFBUTtpQ0FDakI7Z0NBQ0QsWUFBWSxFQUFFO29DQUNaLE1BQU0sRUFBRSxTQUFTO2lDQUNsQjtnQ0FDRCxZQUFZLEVBQUU7b0NBQ1osTUFBTSxFQUFFLFFBQVE7aUNBQ2pCO2dDQUNELFVBQVUsRUFBRTtvQ0FDVixNQUFNLEVBQUUsU0FBUztpQ0FDbEI7Z0NBQ0QsVUFBVSxFQUFFO29DQUNWLE1BQU0sRUFBRSxTQUFTO2lDQUNsQjs2QkFDRjs0QkFDRCxVQUFVLEVBQUU7Z0NBQ1YsTUFBTTs2QkFDUDt5QkFDRjtxQkFDRjtpQkFDRjtnQkFDRCxNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLHNCQUFzQixFQUFFLEtBQUs7b0JBQzdCLG1CQUFtQixFQUFFO3dCQUNuQixhQUFhLEVBQUU7NEJBQ2IsTUFBTSxFQUFFLFFBQVE7NEJBQ2hCLHNCQUFzQixFQUFFLEtBQUs7NEJBQzdCLFlBQVksRUFBRTtnQ0FDWixNQUFNLEVBQUU7b0NBQ04sTUFBTSxFQUFFLE9BQU87b0NBQ2YsT0FBTyxFQUFFO3dDQUNQLE9BQU8sRUFBRTs0Q0FDUDtnREFDRSxNQUFNLEVBQUUsUUFBUTs2Q0FDakI7eUNBQ0Y7cUNBQ0Y7b0NBQ0QsVUFBVSxFQUFFLENBQUM7b0NBQ2IsVUFBVSxFQUFFLENBQUM7aUNBQ2Q7Z0NBQ0QsYUFBYSxFQUFFO29DQUNiLE1BQU0sRUFBRSxRQUFRO2lDQUNqQjtnQ0FDRCxZQUFZLEVBQUU7b0NBQ1osTUFBTSxFQUFFLFNBQVM7aUNBQ2xCO2dDQUNELFlBQVksRUFBRTtvQ0FDWixNQUFNLEVBQUUsUUFBUTtpQ0FDakI7Z0NBQ0QsTUFBTSxFQUFFO29DQUNOLE1BQU0sRUFBRSxPQUFPO2lDQUNoQjtnQ0FDRCxVQUFVLEVBQUU7b0NBQ1YsTUFBTSxFQUFFLFNBQVM7aUNBQ2xCOzZCQUNGOzRCQUNELFVBQVUsRUFBRTtnQ0FDVixNQUFNOzZCQUNQO3lCQUNGO3FCQUNGO2lCQUNGO2dCQUNELFlBQVksRUFBRTtvQkFDWixNQUFNLEVBQUUsUUFBUTtpQkFDakI7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixhQUFhO2FBQ2Q7U0FDRjtRQUNELGVBQWUsRUFBRTtZQUNmLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixRQUFRLEVBQUU7b0JBQ1IsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLFlBQVksRUFBRTt3QkFDWixNQUFNLEVBQUU7NEJBQ04sTUFBTSxFQUFFLE9BQU87NEJBQ2YsT0FBTyxFQUFFO2dDQUNQLE1BQU0sRUFBRSxRQUFRO2dDQUNoQixZQUFZLEVBQUU7b0NBQ1osSUFBSSxFQUFFO3dDQUNKLE1BQU0sRUFBRSxRQUFRO3dDQUNoQixTQUFTLEVBQUUsbUJBQW1CO3FDQUMvQjtvQ0FDRCxNQUFNLEVBQUU7d0NBQ04sTUFBTSxFQUFFLFFBQVE7d0NBQ2hCLE1BQU0sRUFBRTs0Q0FDTixpQkFBaUI7eUNBQ2xCO3FDQUNGO2lDQUNGOzZCQUNGO3lCQUNGO3FCQUNGO2lCQUNGO2dCQUNELFVBQVUsRUFBRTtvQkFDVixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsWUFBWSxFQUFFO3dCQUNaLE1BQU0sRUFBRTs0QkFDTixNQUFNLEVBQUUsT0FBTzs0QkFDZixPQUFPLEVBQUU7Z0NBQ1AsTUFBTSxFQUFFLFFBQVE7Z0NBQ2hCLFlBQVksRUFBRTtvQ0FDWixJQUFJLEVBQUU7d0NBQ0osTUFBTSxFQUFFLFFBQVE7cUNBQ2pCO29DQUNELE1BQU0sRUFBRTt3Q0FDTixNQUFNLEVBQUUsUUFBUTt3Q0FDaEIsTUFBTSxFQUFFOzRDQUNOLG1CQUFtQjt5Q0FDcEI7cUNBQ0Y7aUNBQ0Y7NkJBQ0Y7eUJBQ0Y7cUJBQ0Y7aUJBQ0Y7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osSUFBSTtRQUNKLE1BQU07S0FDUDtDQUNGLENBQUEifQ==